// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/blocks/style.pcss
// module id = 122
// module chunks = 0